<div class="panel panel-flat">
  <div class="content-group">
    <div class="page-header page-header-default">
      <div class="page-header-content">
        <div class="page-title">
          <h5>
            <i class="icon-comments position-left"></i>
            <span class="text-semibold">Comments</span>
          </h5>
        </div>

        <div class="heading-elements">
          <div class="btn-group pull-right">
            <!-- <a [routerLink]="['/commentsadd']" type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-add position-left"></i> Add Comment</a> -->
            <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-printer position-left"></i>Print</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="padding-left:30px;">
      <div class="col-md-3 form-group required">
        <span style="float:left" class="control-label">Filter by: </span>
        <select name="status" required [(ngModel)]="filter" (ngModelChange)="getCommentsFilter(filter)"
          class="form-control">
          <option selected disabled>Status</option>
          <option value="&status=">All</option>
          <option value="&status=unread">Unread</option>
          <option value="&status=read">Read</option>
        </select>
      </div>

      <div class="col-md-3 form-group required">
        <span class="control-label">&nbsp; </span>
      </div>
    </div>

    <div class="panel-body">
      <table class="table datatable-column-search-inputs">
        <thead>
          <tr>
            <th colspan="2">Name</th>
            <th>Email/Phone</th>
            <th>Date</th>
            <th>Message</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let comment of comments | paginate: { id: 'comments',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
            <td>
              <img *ngIf="!comment?.user?.data?.avatar" src="assets/img/userm.png" width="40" height="40"
                class="img-circle img-md" alt="">
              <img *ngIf="comment?.user?.data?.avatar" [src]="baseUrl+'assets/'+comment.user.data.avatar+'/render'"
                width="40" height="40" class="img-circle img-md" alt="">
            </td>
            <td>{{comment.user.data.username}}</td>
            <td>{{comment.user.data.email}}</td>
            <td>{{comment.created_at|date:short}}</td>
            <td>{{comment.comment}}</td>
            <td>
              <span class="label label-block label-default"
                *ngIf="comment.status === 'Read' || comment.status === 'read'">{{comment.status}}</span>
              <span class="label label-block label-primary"
                *ngIf="comment.status === 'Unread' || comment.status === 'unread'">{{comment.status}}</span>
            </td>
            <td class="text-center">
              <ul class="icons-list">
                <li class="dropdown">
                  <a href="" class="dropdown-toggle" data-toggle="dropdown">
                    <i class="icon-menu9"></i>
                  </a>

                  <ul class="dropdown-menu dropdown-menu-right">
                    <li>
                      <a href="">
                        <i class="icon-file-pdf"></i>Update</a>
                    </li>
                    <li class="dropdown-submenu dropdown-submenu-left">
                      <a href="javascript:void(0);">Change Status</a>
                      <ul class="dropdown-menu">
                        <li>
                          <a (click)="changeStatus(comment.id,'read')">
                            <i class="icon-shuffle"></i> Read</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(comment.id,'unread')">
                            <i class="icon-shuffle"></i> Unread</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
          <tr *ngIf="comments.length <= 0">
            <td colspan="7" class="text-center"><i class="icon-info22">&nbsp;</i> No Comments Found</td>
          </tr>
        </tbody>
      </table>


      <div class="row">
        <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
        <div class="text-center">

          <pagination-controls id="comments" (pageChange)="pageChanged(currentPage = $event)">
          </pagination-controls>

          <br>
        </div>

      </div>


    </div>
  </div>
</div>